import { useEffect,useState } from "react"
import axios from "axios"
export default function DelCliente({clientes,setClientes}){
    const [error,setError]=useState(false)
    const [acierto,setAcierto]=useState(false)
    const [id,setId]=useState(clientes[0].id)
    useEffect(()=>{
        
    },[])
    const Click=()=>{
        axios.delete(`https://www.asinova.es/webapi/api/Clientes/${id}`).then(()=>{
            setClientes(clientes.filter(x=>x.id!=id));
            setAcierto(true)})
    }
    return (
        <div>
            <h1 style={{textAlign:'center'}}>ELIMINAR CLIENTE</h1>
            <div className="formulario-vertical"  style={error?null:{marginBottom:'1rem'}}>
                <select name="cliente" id="cliente" onChange={(e)=>{setId(e.target.value);setAcierto(false)}}>
                    {
                        clientes.map((x)=>(
                            <option value={x.id}>{x.nombre}</option>
                        ))
                    }
                </select>
            </div>
            {acierto?<p className="aqua" style={{textAlign:'center'}}><b>Cliente eliminado con éxito</b></p>:null}
            <a className='btn-form' style={{margin:'0 auto',width:'fit-content',display:'block'}} onClick={Click}>Enviar</a>
        </div>
    )
}